import { computed, toJS } from "mobx";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { InputText } from "primereact/inputtext";
import React, { useState, useEffect } from "react";

import SelectingOptions from "../SelectingOptions";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const DefaultCard = inject("mainStore")(
    observer(({ mainStore, item, changeableData }) => {
        const isHit = changeableData?.offerOptions?.includes("hit");
        const type = item?.previewType || item.typeQuestions || "";
        const isVerified = changeableData?.inputFields?.find((item) => item?.isVerified === true);

        const termsOfUse =
            changeableData && changeableData.offerDetail && changeableData.offerDetail.termsOfUse
                ? changeableData.offerDetail.termsOfUse.replace(/{{dateEnd}}/gim, moment(changeableData.dateEnd).format("DD.MM.YYYY")).replace(/{{dateStart}}/gim, moment(changeableData.dateStart).format("DD.MM.YYYY"))
                : "";

        const renderBody = () => {
            switch (type) {
                case "previewMobile":
                    return (
                        <div className="content__offer">
                            <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали <span>5942 человек</span>
                            </div>

                            <div className="form">
                                {changeableData?.offerDetail?.showInputsInModal ? null : (
                                    <>
                                        {isVerified ? (
                                            <div className={`steps`}>
                                                <div className={`steps__line  ${" steps__line_25"}`}></div>
                                                <div className="steps__wrapper">
                                                    <div className={`steps__step_active `}>
                                                        <p>{"1"}</p>
                                                    </div>
                                                    <div className={`steps__step`}>
                                                        <p>2</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                    </>
                                )}
                                {changeableData?.inputFields?.map((i, idx) => (
                                    <InputText key={idx} placeholder={i.type === "phone" ? "+7 (___) ___-__-__" : i.placeholder} className="input_email" disabled />
                                ))}

                                <div className="form__captcha">
                                    <div className="form__button">
                                        <ButtonUI label={"Получить предложение"} id="button_send" className="form__button_get-offer" />
                                        <div className="share mobile">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.22825 5.2405V1.59961L15.598 7.97117L9.22825 14.3427V10.7018C4.67846 10.7018 2.55995 12.3996 0.399994 14.3996C1.83203 9.59961 3.27091 7.82045 4.63203 6.79961C5.99314 5.77877 7.22067 5.44016 9.22825 5.2405Z"
                                                    fill="#1e22aa"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <span className="form__desc">
                                    Нажимая кнопку «Получить предложение», я соглашаюсь с{" "}
                                    <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" rel="noreferrer">
                                        политикой конфиденциальности
                                    </a>
                                    , а также даю согласие{" "}
                                    <a href=" https://ris.promo/pdf/processing_of_personal_data.pdf" target="_blank">
                                        ООО &quot;РИС&quot;
                                    </a>{" "}
                                    на направление мне рекламных сообщений и на обработку персональных данных.
                                </span>
                            </div>
                            <div className="form__ord">{changeableData?.offerDetail?.ordRisPromo}</div>
                            <div className="content__offer_description" dangerouslySetInnerHTML={{ __html: changeableData.description }}></div>

                            <div className="content__offer_details_btn">
                                <span>Скрыть</span>
                                {/* <img src={Arrow} /> */}
                            </div>

                            <div className={`content__offer_info open`}>
                                <div className={`content__offer_info_details `} dangerouslySetInnerHTML={{ __html: changeableData?.offerDetail?.termsOfUse }}></div>
                            </div>
                        </div>
                    );
                case "ghostDefault":
                    return (
                        <div>
                            <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали <span>5942 человек</span>
                            </div>

                            <div className="grost__form">
                                <div className="form__header">
                                    <span className="title">{changeableData?.ghostOfferConfig && changeableData?.ghostOfferConfig.textTitle ? changeableData.ghostOfferConfig.textTitle : "Ой, это предложение больше не доступно"}</span>
                                    <span className="desc">{changeableData?.ghostOfferConfig && changeableData?.ghostOfferConfig.textDesc ? changeableData.ghostOfferConfig.textDesc : "Мы пришлем вам письмо, когда предложение снова появятся"}</span>
                                </div>
                                <ButtonUI label="Выбрать другое предложение" className="form__button_get-offer" />
                            </div>
                        </div>
                    );

                case "ghostEmail":
                    return (
                        <div>
                            <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали <span>5942 человек</span>
                            </div>
                            <div className="grost__form">
                                <div className="form__header">
                                    <span className="title">{changeableData?.ghostOfferConfig && changeableData?.ghostOfferConfig.textTitle ? changeableData.ghostOfferConfig.textTitle : "Ой, это предложение больше не доступно"}</span>
                                    <span className="desc">{changeableData?.ghostOfferConfig && changeableData?.ghostOfferConfig.textDesc ? changeableData.ghostOfferConfig.textDesc : "Мы пришлем вам письмо, когда предложение снова появятся"}</span>
                                </div>
                                <InputText placeholder="Укажите Email" className="input_email" />
                                <div className="button__group">
                                    <ButtonUI label="Уведомить меня" className="form__button_get-offer" />

                                    <ButtonUI label="Выбрать другое предложение" className="button__close" />
                                </div>
                            </div>
                        </div>
                    );
                case "ghostHeader":
                    return (
                        <div>
                            <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали <span>5942 человек</span>
                            </div>

                            <div className="grost__form">
                                <div className="form__header">
                                    <span className="title">{changeableData?.ghostOfferConfig && changeableData?.ghostOfferConfig.textAnswer ? changeableData.ghostOfferConfig.textAnswer : "Ой, это предложение больше не доступно"}</span>
                                </div>
                                <ButtonUI label="Выбрать другое предложение" className="form__button_get-offer" />
                            </div>
                        </div>
                    );

                case "questionOff":
                    return (
                        <div>
                            <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали <span>5942 человек</span>
                            </div>

                            <div className="grost__form">
                                <InputText placeholder="Укажите Email" className="input_email" disabled />
                                <ButtonUI label="Получить" className="form__button_get-offer" disabled />
                            </div>
                        </div>
                    );

                case "questionOn":
                    return (
                        <div>
                            <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали <span>5942 человек</span>
                            </div>

                            <div className="grost__form">
                                <div className="form__header">
                                    <span className="title">Закрытый вопрос?</span>
                                    <span className="desc">Это предложение только для новых пользователей</span>

                                    <div className="group__btn">
                                        <div className="quest__btn one">Да</div>
                                        <div className="quest__btn">Нет</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                case "buttons":
                case "radioButtons":
                case "selectSuggest":
                case "checkbox":
                case "city":
                case "region":
                case "metro":
                    return <SelectingOptions item={item} />;
                default:
                    return;
            }
        };

        const vendorImgs = { coverMobile: changeableData?.vendor?.squareLogo };
        const image = changeableData?.coverMobile || vendorImgs?.coverMobile || null;

        return (
            <div className="default-card">
                <div className={`list-item__accordion ${isHit ? "hit" : ""} `}>
                    <div className="list-item__accordion__content">
                        <div className="list-item__accordion__logo">
                            <img src={image} className={`logo_mobile `} />
                        </div>
                        <div className="list-item__accordion__title-container">
                            <span
                                className={`list-item__accordion__title  "big" `}
                                dangerouslySetInnerHTML={{
                                    __html: changeableData.title,
                                }}
                            ></span>
                        </div>
                        {isHit ? <span className={`list-item__accordion__hit-label`}>хит</span> : null}
                    </div>
                    {renderBody()}
                </div>
            </div>
        );
    }),
);

export default DefaultCard;
